import { API_SERVER } from "../config";
import storageUtil from "./storageUtil";

interface IRequestOptions {
  data?: any;
  method?: "GET" | "POST" | "PUT" | "DELETE";
  headers?: { [key: string]: string };
  timeout?: number;
}

export function request(url: string, options?: IRequestOptions) {
  const {
    data = undefined,
    method = "GET",
    headers = {},
    timeout = 60000,
  } = options === undefined ? {} : options;

  // 默认请求头
  let defaultHeaders = {};
  let body: any;
  if (data instanceof FormData) {
    defaultHeaders = {};
    body = data;
  } else if (data != null && typeof data === "object") {
    defaultHeaders = { "Content-Type": "application/json" };
    body = JSON.stringify(data);
  } else {
    defaultHeaders = { "Content-Type": "application/json" };
    body = data;
  }
  // eslint-disable-next-line no-undef
  const abortController = new AbortController();

  // fetch 不支持请求超时设置，这里通过setTimeout模拟超时
  const timeoutPromise = new Promise<Response>(() =>
    setTimeout(() => abortController.abort(), timeout)
  );

  const fetchPromise = fetch(url, {
    method,
    headers: Object.assign(defaultHeaders, headers),
    body,
    signal: abortController.signal,
  });

  return Promise.race([timeoutPromise, fetchPromise]);
}

/**
 * 内部API专用请求方法。
 * >> **该方法可能会将用户凭证写到请求头作为请求凭据，非内部API请求，请勿调用此方法**
 * @param url 请求地址
 * @param options 请求配置
 */
export async function requestForApi(
  url: string,
  options?: IRequestOptions
): Promise<{
  code: number;
  data: any;
  result: boolean;
  status: number;
  message: string;
}> {
  try {
    const defaultHeaders: any = {};

    if (!url.match(/^(http:\/\/)|(https:\/\/)/)) {
      url = `${API_SERVER}${url}`;
    }

    const credential: any = await storageUtil.getItem("CREDENTIAL", true);

    if (url.includes("/oauth/token")) {
      defaultHeaders.Authorization = "Basic cGM6MTIzNDU2";
    } else if (url.includes("/open")) {
      defaultHeaders.Authorization = "";
    } else if (credential && credential.accessToken) {
      defaultHeaders.Authorization = `Bearer ${credential.accessToken}`;
    }
    if (options === undefined) {
      options = { headers: { ...defaultHeaders } };
    } else if (options.headers === undefined) {
      options.headers = { ...defaultHeaders };
    } else {
      options.headers = { ...defaultHeaders, ...options.headers };
    }
    // 模拟网络延迟
    // await mockDelay(20000);

    const response = await request(url, options);

    // 服务器异常
    if (response.status >= 500) {
      throw new Error(await response.text());
    }

    const result = await response.json();

    // Token过期
    if (result.status === 401) {
      // 需要跳转到登录页面
      window.location.href = "/workplace";
    }

    return result;
  } catch (error: any) {
    // 记录日志
    let status = 500;
    let message = "请求异常，请稍后再试";
    if (error.message === "Aborted") {
      status = 408;
      message = "请求超时，请稍后再试";
    }
    return { code: status, data: null, result: false, status, message };
  }
}

export function getQueryString(name: string) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}
